

//Data imports
import AccessMatrix from '@/router/access-matrix';
import LicenseKeys from "@/helpers/Constants/LicenseKeys";

//View and component imports
import Title_Customer from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Customer.vue";
import Title_CustomerGroup from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_CustomerGroup.vue";
//import PlannedConstruction from '@/views/landingpages/PlannedConstruction.vue';
//const UnderConstruction = () => import('@/views/landingpages/UnderConstruction.vue')
//const OldGuiFrame = () => import('@/views/landingpages/OldGuiFrame.vue')
//const IsProd = (process.env.NODE_ENV === 'production');

const RouterView = () => import('@/views/landingpages/RouterView.vue')
//customer list
const CustomerList = () => import('@/views/customer/customers/AdminCustomerList.vue')
const ViewCustomer = () => import('@/views/customer/customers/ViewCustomerContainer.vue')
const CustomerDetails = () => import('@/views/customer/customers/CustomerDetails.vue')
const CustomerMachines = () => import('@/views/customer/customers/CustomerMachines.vue')
const CustomerJobs = () => import('@/views/customer/customers/CustomerJobs.vue')
const CustomerLogList = () => import('@/views/customer/customers/CustomerLogList.vue')
//accounts
const CustomerAccountList = () => import('@/views/admin/accounts/CustomerAccountList.vue')
//customer goup
const AdminCustomerGroups = () => import('@/views/customer/group/AdminCustomerGroups.vue')
const ViewCustomerGroupContainer = () => import('@/views/customer/group/ViewCustomerGroupContainer.vue')
const ViewCustomerGroupInfo = () => import('@/views/customer/group/ViewCustomerGroupInfo.vue')



//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.CustomerTrunk.module,
    display: { key: "servicesystem.pages.page_titles.customer" },
    icon: "mdi-domain",
  },
  path: '/customer',
  name: 'Customer',
  component: RouterView,
  redirect: { name: 'CustomerList' },

  children: [
    {
      meta: {
        authorize: AccessMatrix.CustomerTrunk.customerlist,
        display: { key: "servicesystem.pages.page_titles.customer_search" },
        icon: "mdi-domain",
        overrides: {
          header: {
            buttons: ['NewCustomerBtn'],
          },
        },
      },
      name: 'CustomerList',
      path: 'list',
      component: CustomerList,
      children: [
        {
          meta: {
            authorize: AccessMatrix.CustomerTrunk.viewcustomer,
            contextMenu: true,
            overrides: {
              sidebar: false,
              title: Title_Customer,
            },
          },
          name: 'ViewCustomer',
          path: ':customerId',
          component: ViewCustomer,
          redirect: { name: 'CustomerDetails' },

          children: [
            {
              meta: {
                authorize: AccessMatrix.CustomerTrunk.viewcustomer,
                display: { key: "servicesystem.common_objects.commonterms.general" },
                icon: "$customer",
                overrides: {
                  header: {
                    buttons: ['ToggleCustomerActiveBtn', 'TogglePublicViewBtn', 'NewJobBtn'],
                  },
                }
              },
              name: 'CustomerDetails',
              path: 'details',
              component: CustomerDetails,
            },

            {
              meta: {
                authorize: AccessMatrix.CustomerTrunk.viewcustomer,
                display: { key: "servicesystem.common_objects.job.jobs" },
                icon: "$job",
                overrides: {
                  header: {
                    buttons: ['NewJobBtn'],
                  },
                }
              },
              name: 'CustomerJobs',
              path: 'jobs/:jobId?',
              component: CustomerJobs,
            },

            {
              meta: {
                authorize: AccessMatrix.CustomerTrunk.viewcustomer,
                display: { key: "servicesystem.common_objects.machine.machines" },
                icon: "$machine",
                overrides: {
                  header: {
                    buttons: ['TransferAllMachinesBtn', 'NewJobBtn', 'NewDialogTriggerBtn'],
                  },
                }
              },
              name: 'CustomerMachines',
              path: 'machines/:machineId?',
              component: CustomerMachines,
            },

            {
              meta: {
                licenseEnabled: LicenseKeys.CustomerPortal,
                authorize: AccessMatrix.CustomerTrunk.viewcustomer,
                display: { key: "servicesystem.pages.page_titles.admin_accounts_customers" },
                icon: "mdi-account-tie",
                overrides: {
                  header: {
                    buttons: ['NewAccountBtn'],
                  },
                }
              },
              name: 'CustomerUsers',
              path: 'users/:userId?',
              component: CustomerAccountList,
            },

            {
              meta: {
                authorize: AccessMatrix.CustomerTrunk.viewcustomer,
                display: { key: "servicesystem.pages.page_titles.admin_logs" },
                icon: "mdi-timeline-text",
                overrides: {
                  header: {
                    //buttons: ['NewJobBtn'],
                  },
                }
              },
              name: 'CustomerLogs',
              path: 'logs/:logId?',
              component: CustomerLogList,
            },
          ]
        },
      ],
    },

    //loose view pages
    {
      meta: {
        authorize: AccessMatrix.CustomerTrunk.viewcustomer,
        display: { key: "servicesystem.pages.page_titles.customer_view_contact" },
        icon: "mdi-account-tie",
        overrides: {
          sidebar: false,
        }
      },
      name: 'ViewCustomerContact',
      path: 'contact/:contactId?',
      component: ViewCustomer,
    },

    {
      meta: {
        authorize: AccessMatrix.CustomerTrunk.viewcustomer,
        display: { key: "servicesystem.pages.page_titles.view_user" },
        icon: "mdi-account",
        overrides: {
          sidebar: false,
        }
      },
      name: 'ViewUser',
      path: 'user/:userId?',
      component: ViewCustomer,
    },

    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.customers_branch,
        display: { key: "servicesystem.pages.page_titles.admin_customer_groups" },
        icon: "$customer_group",
        overrides: {
          header: {
            buttons: ['NewDialogTriggerBtn'],
          },
        },
      },
      path: "group-list",
      name: "CustomerGroupList",
      component: AdminCustomerGroups,
    },
    {
      meta: {
        authorize: AccessMatrix.AdminTrunk.customers_branch,
        overrides: {
          sidebar: false,
          title: Title_CustomerGroup,
        },
        contextMenu: "Hidden"
      },
      path: "group-list/:customerGroupId?",
      name: "ViewCustomerGroup",
      component: ViewCustomerGroupContainer,
      redirect: { name: 'ViewCustomerGroupInfo' },
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.customers_branch,
            displayName: 'Info',
            icon: "mdi-home",
          },
          path: "info",
          name: "ViewCustomerGroupInfo",
          component: ViewCustomerGroupInfo
        },
      ],
      /*
      children: [
        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.customers_branch,
            display: { key: "servicesystem.common_objects.commonterms.general" },
            icon: "$customer",
            overrides: {
              header: {
                buttons: ['ToggleCustomerActiveBtn', 'TogglePublicViewBtn', 'NewJobBtn'],
              },
            }
          },
          name: 'CustomerDetails',
          path: 'details',
          component: CustomerDetails,
        },

        {
          meta: {
            authorize: AccessMatrix.AdminTrunk.customers_branch,
            display: { key: "servicesystem.common_objects.job.jobs" },
            icon: "$job",
            overrides: {
              header: {
                buttons: ['NewJobBtn'],
              },
            }
          },
          name: 'CustomerJobs',
          path: 'jobs/:jobId?',
          component: CustomerJobs,
        },
      ]
      */
    },

    {
      meta: {
        licenseEnabled: LicenseKeys.CustomerPortal,
        authorize: AccessMatrix.AdminTrunk.accounts_branch,
        display: { key: "servicesystem.pages.page_titles.admin_accounts_customers" },
        icon: "$customer_manager",
        overrides: {
          header: {
            buttons: ['NewAccountBtn'],
          },
        }
      },
      path: 'accounts-list',
      name: 'CustomerAccountList',
      component: CustomerAccountList,
    },
  ]
};

export default trunk;